<template>
  <div id="riskAssessmentGuide">
    <el-card>
      <!-- Phase Tabs -->
      <el-tabs v-model="activePhase" type="card">
        <el-tab-pane label="Project Preparation Phase" name="phase1">
          <div class="risk-table-wrap">
            <el-table :data="phase1Data" border style="width: 100%" height="600" :header-cell-style="{background:'#FAFAFA'}">
              <el-table-column prop="seqNo" label="No." align="center" width="45"></el-table-column>
              <el-table-column prop="riskIdentificationPhase" label="Risk Identification Phase" align="left" min-width="100"></el-table-column>
              <el-table-column prop="riskCategory" label="Risk Category" align="left" min-width="110"></el-table-column>
              <el-table-column prop="identificationMethod" label="Risk Identification Method" align="left" min-width="140"></el-table-column>
              <el-table-column prop="riskPoints" label="Key Risk Points" align="left" min-width="300"></el-table-column>
              <el-table-column prop="potentialImpact" label="Potential Impact" align="left" min-width="220"></el-table-column>
              <el-table-column prop="countermeasures" label="Countermeasures" align="left" min-width="400"></el-table-column>
              <el-table-column prop="owner" label="Owner" align="left" min-width="110"></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Project Monitoring Phase" name="phase2">
          <div class="risk-table-wrap">
            <el-table :data="phase2Data" border style="width: 100%" height="600" :header-cell-style="{background:'#FAFAFA'}">
              <el-table-column prop="seqNo" label="No." align="center" width="45"></el-table-column>
              <el-table-column prop="riskIdentificationPhase" label="Risk Identification Stage" align="left" min-width="100"></el-table-column>
              <el-table-column prop="riskCategory" label="Risk Category" align="left" min-width="110"></el-table-column>
              <el-table-column prop="identificationMethod" label="Risk Identification Method" align="left" min-width="140"></el-table-column>
              <el-table-column prop="riskPoints" label="Main Risk Point" align="left" min-width="300"></el-table-column>
              <el-table-column prop="potentialImpact" label="Potential Impact" align="left" min-width="220"></el-table-column>
              <el-table-column prop="countermeasures" label="Mitigation Measures" align="left" min-width="400"></el-table-column>
              <el-table-column prop="owner" label="Owner" align="left" min-width="110"></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Acceptance and Handover Phase" name="phase3">
          <div class="risk-table-wrap">
            <el-table :data="phase3Data" border style="width: 100%" height="600" :header-cell-style="{background:'#FAFAFA'}">
              <el-table-column prop="seqNo" label="No." align="center" width="45"></el-table-column>
              <el-table-column prop="riskIdentificationPhase" label="Risk Identification Stage" align="left" min-width="100"></el-table-column>
              <el-table-column prop="riskCategory" label="Risk Category" align="left" min-width="110"></el-table-column>
              <el-table-column prop="identificationMethod" label="Risk Identification Method" align="left" min-width="140"></el-table-column>
              <el-table-column prop="riskPoints" label="Main Risk Point" align="left" min-width="300"></el-table-column>
              <el-table-column prop="potentialImpact" label="Potential Impact" align="left" min-width="220"></el-table-column>
              <el-table-column prop="countermeasures" label="Mitigation Measures" align="left" min-width="400"></el-table-column>
              <el-table-column prop="owner" label="Owner" align="left" min-width="110"></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!-- Attachment Section (outside tabs) -->
      <div class="attachment-section">
        <div class="attachment-title">Risk Assessment Guide</div>
        <!-- File Info (clickable for download) -->
        <div class="file-info-row" v-if="fileInfo" @click="handleDownload">
          <i class="el-icon-document"></i>
          <span class="file-name">{{ fileInfo.fileName }}</span>
          <span class="file-meta" v-if="fileInfo.fileSize">{{ fileInfo.fileSize }}</span>
          <span class="file-meta" v-if="fileInfo.uploadTime">{{ fileInfo.uploadTime }}</span>
          <i class="el-icon-download file-download-icon"></i>
        </div>
        <!-- Upload Button (only when editing) -->
        <div class="upload-area" v-if="isSystemAdmin">
          <el-upload
            action=""
            :auto-upload="false"
            accept=".xlsx,.xls"
            :on-change="handleFileChange"
            :on-remove="handleRemoveFile"
            :file-list="fileList"
          >
            <el-button size="small" type="primary"><i class="el-icon-upload2"></i> Upload Excel</el-button>
          </el-upload>
        </div>
      </div>

      <!-- Footer Buttons -->
      <div class="page-footer">
        <el-button v-if="isSystemAdmin" type="primary" size="small" :loading="saveLoading" :disabled="!fileList.length" @click="handleSave">Save</el-button>
        <el-button size="small" @click="handleClose">Close</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'RiskAssessmentGuide',
  created() {
    this.loadData()
  },
  computed: {
    isSystemAdmin() {
      const roleName = sessionStorage.getItem('roleName') || '';
      return roleName.indexOf('SystemAdmin') !== -1;
    }
  },
  data() {
    return {
      activePhase: 'phase1',
      saveLoading: false,
      // Phase 1 data
      phase1Data: [],
      // Phase 2 data
      phase2Data: [],
      // Phase 3 data
      phase3Data: [],
      // Upload file list (single Excel for all phases)
      fileList: [],
      // Current file info
      fileInfo: null,
    }
  },
  methods: {
    loadData() {
      const baseUrl = this.$store.state.islhurl;
      const phases = [
        { key: 'phase1Data', phase: 'PREPARATION' },
        { key: 'phase2Data', phase: 'MONITORING' },
        { key: 'phase3Data', phase: 'HANDOVER' },
      ];
      phases.forEach(({ key, phase }) => {
        let url = `${baseUrl}risk/guide/list?phase=${phase}`;
        this._get(url).then(res => {
          if (res.code === 200) {
            this[key] = res.data || [];
          } else {
            this.$message.error(res.msg || 'Failed to load guide data');
          }
        }).catch(() => {
          this[key] = [];
        });
      });
      this.loadFileInfo();
    },
    loadFileInfo() {
      const url = `${this.$store.state.islhurl}risk/guide/file`;
      this._get(url).then(res => {
        if (res.code === 200 && res.data) {
          this.fileInfo = {
            fileName: res.data.fileName,
            fileSize: res.data.fileSizeDesc,
            uploadTime: res.data.uploadTime,
          };
        } else {
          this.fileInfo = null;
        }
      }).catch(() => {
        this.fileInfo = null;
      });
    },

    handleSave() {
      if (!this.fileList.length) {
        this.$message.warning('Please select an Excel file to upload first');
        return;
      }
      this.saveLoading = true;
      const url = `${this.$store.state.islhurl}risk/guide/upload`;
      const formData = new FormData();
      formData.append('file', this.fileList[0].raw);
      this._post(url, formData, {
        noProgress: false,
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then(res => {
        this.saveLoading = false;
        if (res.code === 200) {
          this.fileList = [];
          this.$message.success('Upload successfully! Data has been updated.');
          this.loadData();
        } else {
          this.$message.error(res.msg || 'Upload failed!');
        }
      }).catch(() => {
        this.saveLoading = false;
        this.$message.error('Upload failed!');
      });
    },
    handleClose() {
      this.$router.push('/riskManagement');
    },
    handleFileChange(file, fileList) {
      const ext = file.name.split('.').pop().toLowerCase();
      if (ext !== 'xlsx' && ext !== 'xls') {
        this.$message.error('Only Excel files (.xlsx / .xls) are allowed!');
        // Remove the invalid file from list
        this.fileList = fileList.filter(f => f.uid !== file.uid);
        return;
      }
      // Only keep the latest file
      this.fileList = [file];
    },
    handleRemoveFile() {
      this.fileList = [];
    },
    handleDownload() {
      const url = `${this.$store.state.islhurl}risk/guide/download`;
      this.$axios.get(url, { responseType: 'blob' }).then(res => {
        const data = res.data;
        if (data.type && data.type.includes('application/json')) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const err = JSON.parse(reader.result);
              this.$message.error(err.msg || 'Download failed!');
            } catch (e) {
              this.$message.error('Download failed!');
            }
          };
          reader.readAsText(data);
          return;
        }
        const fileName = this.fileInfo ? this.fileInfo.fileName : 'Risk Assessment Guide.xlsx';
        const blob = new Blob([data]);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }).catch(() => {
        this.$message.error('Download failed!');
      });
    },
  }
}
</script>

<style lang="less" scoped>
#riskAssessmentGuide {
  /deep/.el-tabs--card > .el-tabs__header .el-tabs__item {
    font-size: 13px;
  }
  /deep/.el-tabs__content {
    padding: 0;
  }
  .risk-table-wrap {
    /deep/.el-table--border {
      border: 1px solid #cbcbcb;
    }
    /deep/.el-table--border th, /deep/.el-table--border td {
      border-right: 1px solid #E5E7EB;
    }
  }
  /deep/.el-table .cell {
    white-space: pre-line;
    word-break: break-word;
    line-height: 1.6;
    font-size: 12px;
  }
  /deep/.el-table th .cell {
    white-space: pre-line;
    font-size: 12px;
  }

  .attachment-section {
    margin-top: 16px;
    .attachment-title {
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 6px;
      padding-top: 4px;
    }
    .file-info-row {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 6px 0;
      cursor: pointer;
      &:hover .file-name {
        text-decoration: underline;
      }
      > i:first-child {
        font-size: 17px;
        color: #007AFF;
      }
      .file-name {
        font-size: 13px;
        color: #007AFF;
      }
      .file-meta {
        font-size: 12px;
        color: #9CA3AF;
      }
      .file-download-icon {
        font-size: 14px;
        color: #007AFF;
        margin-left: 2px;
      }
    }
    .upload-area {
      margin-top: 10px;
      /deep/ .el-upload-list__item-name {
        max-width: 400px;
      }
      /deep/ .el-upload-list {
        width: 400px
      }
    }
  }

  .page-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 20px 0 30px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/riskmanagement/riskAssessmentGuide.vue